<template>
  <v-ons-modal
    :visible.sync="modalVisible"
    class="modal-language" animation="fade"
  >
    <div style="text-align: center">
      <p>{{ $t("language_select.label") }}</p>
      <v-ons-select modifier="autofocus" class="choose-lang" required="true" v-model="selectedLangCode">
        <option v-for="lang in uiLanguages" :value="lang.code" :key="lang.code">{{ lang.title }}</option>
      </v-ons-select>
      <v-ons-button modifier="large" class="js-confirm-language" @click="setLang" :disabled="loading">{{ loading ? $t("language_select.loading") : $t("language_select.go") }}</v-ons-button>
      <p class="note">{{ $t("language_select.note") }}</p>
    </div>
  </v-ons-modal>
</template>

<script>
import { uiLanguages, i18n, loadLanguageAsync } from '@/i18n';

export default {
  props: ['doneCallback'],

  data() {
    return {
      loading: false,
      modalVisible: false,
      selectedLangCode: i18n.locale,
      uiLanguages: uiLanguages.filter((lang) => lang.code === i18n.locale).concat(uiLanguages.filter((lang) => lang.code !== i18n.locale)),
    };
  },

  methods: {
    setLang() {
      this.loading = true;
      loadLanguageAsync(this.selectedLangCode).then(() => {
        this.modalVisible = false;
        if (this.doneCallback) {
          setTimeout(this.doneCallback, 0);
        }
        this.$destroy();
      });
    },
  },

  mounted() {
    this.modalVisible = true;
  },
};
</script>